<template>
    <default-item class="mothers_day_food_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout"></default-item>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2025-05-05 (1.0.0) (jhoward)
 *      - <easterFoodItem> copied to <mothersDayFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'mothers-day-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>
.mothers_day_food_item--container {
  text-align: center;
}

.mothers_day_food_item--container:deep(.visual_menu--item_title) {
  font-weight: normal;
}

.mothers_day_food_item--container:deep(.menu--tag) {
  position: absolute;
  right: 0;
  top: 1em;
  width: 4em;
  height: 4em;
}
</style>